type RoundingStrategy = 'none' | 'nearest' | 'up' | 'down';
export type RoundingMode =
  | 'none'
  | 'nearest_nickel'
  | 'nearest_dollar'
  | 'up_dollar'
  | 'down_dollar';

interface RoundingModeEntry {
  increment: number | null;
  label: string;
  mode: RoundingMode;
  strategy: RoundingStrategy;
}

const ROUNDING_MODES: RoundingModeEntry[] = [
  { mode: 'none', label: 'None', strategy: 'none', increment: null },
  {
    mode: 'nearest_nickel',
    label: 'Nearest nickel',
    strategy: 'nearest',
    increment: 0.05,
  },
  {
    mode: 'nearest_dollar',
    label: 'Nearest dollar',
    strategy: 'nearest',
    increment: 1.0,
  },
  {
    mode: 'up_dollar',
    label: 'Dollar -- always round up',
    strategy: 'up',
    increment: 1.0,
  },
  {
    mode: 'down_dollar',
    label: 'Dollar -- always round down',
    strategy: 'down',
    increment: 1.0,
  },
];

export const roundingModeOptions = ROUNDING_MODES.map(({ mode, label }) => ({
  label,
  value: mode,
}));

export const roundingModeToParams: Record<
  RoundingMode,
  { increment: number | null; strategy: RoundingStrategy }
> = Object.fromEntries(
  ROUNDING_MODES.map(({ mode, strategy, increment }) => [
    mode,
    { strategy, increment },
  ])
) as Record<
  RoundingMode,
  { increment: number | null; strategy: RoundingStrategy }
>;

export const paramsToRoundingMode = (
  strategy: RoundingStrategy | undefined,
  increment: number | null | undefined
): RoundingMode => {
  const found = ROUNDING_MODES.find(
    (entry) => entry.strategy === strategy && entry.increment === increment
  );
  return found?.mode ?? 'none';
};

export const getRoundingLabel = (
  strategy: string | undefined,
  increment: number | null | undefined
): string | null => {
  if (!strategy || strategy === 'none' || !increment) return null;
  const found = ROUNDING_MODES.find(
    (entry) => entry.strategy === strategy && entry.increment === increment
  );
  return found?.label ?? null;
};
